var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChangePolicy',_vm._b({},'ChangePolicy',_vm.funnelData,false))
}
var staticRenderFns = []

export { render, staticRenderFns }